module.exports = __webpack_public_path__ + "img/categorie-huitres-plates-famille-boutrais.72ed4ca7.jpg";